















































































import Vue, { PropType } from 'vue'
import models from '@/mixins/models-mixin'
import Person from '@/types/Person.interface'
import Group from '@/types/Group.interface'
import GroupSelector from '@/components/GroupSelector.vue'
export default Vue.extend({
    mixins: [models],
    components: { GroupSelector },
    props: {
        //  An array of person being added to a group
        persons: {
            type: Array as PropType<Person[]>,
            required: false
        },
        //  Determines if we go to the group route after adding a contact to it
        push: {
            type: Boolean,
            default: true
        },
        //  Adds a third 'save for later' option that pushes the selected persons into the PersonsQueue
        saveForLater: {
            type: Boolean,
            default: false
        },
        //  Our starting step
        startStep: {
            type: Number,
            default: null
        },
        //  Adds a 'title' to step1 of the form
        title: {
            type: [String, Function],
            default: null
        }
    },
    data() {
        return {
            //  The loading spinner for 'save' operations
            loading: false,
            //  The max width of the menu list
            maxWidth: '360px',
            //  The group selected when adding persons to an existing group
            selectedGroup: null,
            //  The group name entered when adding persons to a new group
            groupName: null,
            //  The current step of the form stepper
            step: 1
        }
    },
    mounted() {
        //  IF we have a startStep then start on that step
        this.step = this.startStep || 1
    },
    computed: {
        //  The options displayed in Step 1
        cards() {
            //  Assemble the default cards
            const cards = [
                {
                    title: 'Create New group',
                    text: `Add the selected contacts to a new static group`,
                    icon: 'mdi-account-multiple-plus',
                    click: () => (this.step = 2)
                },
                {
                    title: 'Add to Existing Group',
                    text: `Add the selected contacts to an existing static group`,
                    icon: 'mdi-account-multiple-check',
                    click: () => (this.step = 3)
                }
            ]

            //  If the 'saveForLater' prop is true, add the save for later option
            if (this.saveForLater) {
                cards.push({
                    title: 'Save for later',
                    text: `Save the selected contacts to a temporary list.  Use this option to persist selections while searching or filtering.`,
                    icon: 'mdi-content-save-move',
                    click: () => this.addToPersonsQueue()
                })
            }

            return cards
        },
        //  The height of the menu list
        height(): string {
            //  Set the base height
            let height = 220

            //  If a title exists, add 30 pixels
            if (this.title) height = height + 30

            //  If the 'saveForLater' option is active, add 165 pixels
            if (this.saveForLater) height = height + 142

            //  Return the calculated height
            return `${height}px`
        },
        personsCount(): number {
            return this.persons?.length || 0
        }
    },
    methods: {
        //  Adds the persons prop to an existing group provided as the sole argument
        async addToExistingGroup(group: Group): Promise<void> {
            //  Start the loading spinner
            this.loading = true

            //  Get the ids from the personsQueue
            const idsToAdd = this.persons.map((x) => x.id)

            //  Update the group's persons_ids
            group.persons_ids = [...new Set([...group.persons_ids, ...idsToAdd])]

            //  Update the group
            const response = await this.$store.dispatch('groupsPut', group)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed do nothing
            if (!response) return

            //  Publish the 'submitted' event
            this.$emit('submitted')

            //  Notify the user of success
            this.$store.commit('appNotificationBarSet', {
                message: `${group.persons_ids.length} Contact(s) added to ${group.name}`
            })

            //  If our push prop is true, then navigate to the group
            if (this.push) this.$router.push(`/groups/${response.id}`)

            //  Publish the submit event
            this.$emit('submit', response)
        },
        //  Adds the persons prop to a new group that we are creating
        async addToNewGroup(): Promise<void> {
            this.loading = true

            //  Create a new group
            const group = this.newStaticGroup()

            //  Set the group name
            group.name = this.groupName

            //  Set the new group's person ids
            group.persons_ids = this.persons.map((x) => x.id)

            //  Post the new group
            const response = await this.$store.dispatch('groupsPost', group)

            //  Stop the loading spinner
            this.loading = false

            //  If the request failed, do nothing
            if (!response) return

            //  Navigate to the group
            this.$router.push(`/groups/${response.id}`)

            //  Publish the 'submitted' event
            this.$emit('submitted')

            //  Notify the user of success
            this.$store.commit('appNotificationBarSet', {
                message: `${this.personsCount} Contact(s) added to New Group ${group.name}`
            })
        },
        //  Adds the persons prop to our persons queue
        addToPersonsQueue(): void {
            // Get the persons
            const persons = this.persons

            //  Add the persons to the persons queue
            this.$store.commit('personsQueueAdd', persons)

            //  Close our menu
            this.menu = false

            //  Publish the 'submit' event
            this.$emit('submitted')
        },
        //  The style of our cards
        boxStyle(): object {
            return {
                border: `1px solid ${this.$colors.primary}`,
                borderRadius: '10px',
                padding: '16px',
                color: 'black'
            }
        },
        //  Sets the current step on our v-stepper
        setStep(val: number): void {
            this.step = val
        }
    },
    watch: {
        step(val: number): void {
            if (val === 2) {
                //  We use setTimeout here to focus does screw up the stepper animation
                setTimeout(() => {
                    this.$refs.groupNameInput.focus()
                }, 500)
            }
            if (val === 3) {
                setTimeout(() => {
                    this.$refs.groupSelector.focus()
                }, 500)
            }
        }
    }
})
